/**
 * Calculates SDMT score or total filled fields for historyview
 */

import { defaultTo } from 'ramda';

// Calculate total filled fields per document
const calculateSDMTTotals = d => {
  for (let i = 0; i < d.length; i++) {
    d[i] = {
      ...d[i],
      score: 0,
      filled: 0,
    };
    const sdmtResult = safelyHandleValue(d[i], 'sdmtResult');
    if (sdmtResult) {
      const answers = safelyHandleValue(sdmtResult, 'testAnswers');
      d[i].score = safelyHandleValue(sdmtResult, 'rightAnswerCount');
      d[i].filled = answers.length;
    }
  }
  return d;
};

const safelyHandleValue = (obj, val) => defaultTo(null, obj[val]);

export default calculateSDMTTotals;
